import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import { AccordionField } from './AccordionField';

export const AccordionFieldExtension = FormFieldBlueprint.make({
  name: 'accordion-field',
  params: {
    field: async () =>
      createFormField({
        name: 'AccordionField',
        component: AccordionField as any,
        schema: makeFieldSchema({
          output: z => z.record(z.string(), z.unknown()),
          uiOptions: z =>
            z.object({
              accordionTitle: z
                .string()
                .optional()
                .describe(
                  'Title shown in the accordion summary. Defaults to the field schema title',
                ),
              defaultExpanded: z
                .boolean()
                .optional()
                .describe('Whether the accordion starts expanded'),
            }),
        }),
      }),
  },
});
